export enum ShippingMethodCodes {
    vetCourier = 'vetCourier_vetCourier',
    vetWarehousePickup = 'vetWarehousePickup_vetWarehousePickup',
    dropshipping = 'dropshipping_dropshipping',
}
